export default "__VITE_ASSET__BLHnp1kQ__"